<template>
    <b-card-text>
      <b-row>
        <b-col md="8" lg="9">
          <b-form-input
            v-model="input_filter"
            placeholder="Filter..."
            class="mb-3"
          ></b-form-input>

          <Items
            :items="filter(input_filter, slot_items.items)"
            :input="input"
            :quality="quality"
            :item_slot="item_slot"
            class="mb-3"
          ></Items>
        </b-col>
        <b-col lg="3" md="4">
          <b-form-select
            class="d-block d-sm-none"
            v-model="input.paint.value"
            :options="paints"
            :disabled="paintDisabled()"
          ></b-form-select>
          <b-form-radio-group
            class="d-none d-sm-block paint-select"
            v-model="input.paint.value"
            :options="paints"
            buttons
            stacked
            :disabled="paintDisabled()"
            button-variant="outline-secondary"
          ></b-form-radio-group>
        </b-col>
      </b-row>
    </b-card-text>
</template>

<script>
import Items from './Items.vue'

var paints = [
  {html: '<span class="paint-unpainted radio-paint">Unpainted</span>', value: ''},
  {html: '<span class="paint-black radio-paint">Black', value: 'Black'},
  {html: '<span class="paint-burnt-sienna radio-paint">Burnt Sienna</span>', value: 'Burnt Sienna'},
  {html: '<span class="paint-cobalt radio-paint">Cobalt</span>', value: 'Cobalt'},
  {html: '<span class="paint-crimson radio-paint">Crimson</span>', value: 'Crimson'},
  {html: '<span class="paint-forest-green radio-paint">Forest Green</span>', value: 'Forest Green'},
  {html: '<span class="paint-gold radio-paint">Gold</span>', value: 'Gold'},
  {html: '<span class="paint-grey radio-paint">Grey</span>', value: 'Grey'},
  {html: '<span class="paint-lime radio-paint">Lime</span>', value: 'Lime'},
  {html: '<span class="paint-orange radio-paint">Orange</span>', value: 'Orange'},
  {html: '<span class="paint-pink radio-paint">Pink</span>', value: 'Pink'},
  {html: '<span class="paint-purple radio-paint">Purple</span>', value: 'Purple'},
  {html: '<span class="paint-saffron radio-paint">Saffron</span>', value: 'Saffron'},
  {html: '<span class="paint-sky-blue radio-paint">Sky Blue</span>', value: 'Sky Blue'},
  {html: '<span class="paint-titanium-white radio-paint">Titanium White</span>', value: 'Titanium White'},
];

// var paints = [
//   {text: 'Unpainted', value: ''},
//   'Black',
//   'Burnt Sienna',
//   'Cobalt',
//   'Crimson',
//   'Forest Green',
//   'Gold',
//   'Grey',
//   'Lime',
//   'Orange',
//   'Pink',
//   'Purple',
//   'Saffron',
//   'Sky Blue',
//   'Titanium White'
// ];

export default {
  name: 'ItemTab',
  data() {
    return {
      input_filter: '',
      paints: paints,
      quality: this.slot_items.quality,
      paintable: this.slot_items.paintable
    }
  },
  props: {
    slot_items: Object,
    input: Object,
    item_slot: String
  },
  components: {
    Items
  },
  methods: {
    paintDisabled: function() {
      if (!this.paintable[this.input.item.value]) {
        this.input.paint.value = '';
        return true;
      }
      return false;
    },
    filter: function(needle, haystack) {
			return haystack.filter(i => i.toUpperCase().includes(needle.toUpperCase()))
    }
  }
}
</script>